import type { DocumentClass } from "@/views/DocumentWorkspace/documentWorkspaceData";

/** P0-1 — the controlled classification list. */
const CLASS_META: Record<DocumentClass, { label: string; className: string }> =
  {
    "protocol-class": {
      label: "Protocol",
      className: "bg-[#EDE9FE] text-[#6B21A8]",
    },
    plan: { label: "Plan", className: "bg-[#D2EFF9] text-[#06709B]" },
    correspondence: {
      label: "Correspondence",
      className: "bg-[#E0F2F1] text-[#00695C]",
    },
    reference: { label: "Reference", className: "bg-[#E8EAF6] text-[#3949AB]" },
    other: { label: "Other", className: "bg-[#F0F2F4] text-[#6B7280]" },
  };

export function DocumentClassBadge({
  documentClass,
}: {
  documentClass: DocumentClass;
}) {
  const meta = CLASS_META[documentClass];

  return (
    <span
      className={`inline-flex h-5 items-center rounded-[4px] px-1.5 text-[12px] font-semibold ${meta.className}`}
    >
      {meta.label}
    </span>
  );
}
